import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";

const SelectableTable = ({ headers, rows, selected, onSelect, forcedToSwitchedOn={} }) => {
  let genericKey = 0;
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {headers.map(header => (
            <TableCell key={genericKey++}>{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(({ key, row }) => (
          <TableRow key={genericKey++} selected={!!selected[key]}>
            <TableCell key={genericKey++}>
              <Checkbox
                checked={!!selected[key] || !!forcedToSwitchedOn[key]}
                onChange={event =>
                  onSelect({ key, value: event.target.checked })
                }
                disabled={!!forcedToSwitchedOn[key]}
              />
            </TableCell>
            {row.map(cell => (
              <TableCell key={genericKey++}>{cell}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SelectableTable;
